export type WarehouseRecountLabelSave = "print-location" | "carve";

/**
 * Part number on the on-hand card for the current lookup.
 * An empty committed search, or a fetched row from the previous lookup, hides the card.
 */
export function warehouseRecountOnHandCardPartNumber(input: {
  committedSku: string;
  fetchedPartNumber: string | null | undefined;
}): string | null {
  const committed = input.committedSku.trim();
  const fetched = input.fetchedPartNumber?.trim() ?? "";
  if (committed === "" || fetched === "") {
    return null;
  }
  if (fetched.toUpperCase() !== committed.toUpperCase()) {
    return null;
  }
  return fetched;
}

/**
 * SKU posted by print location and carve. The search box is never the payload.
 * No card part number means do not post.
 */
export function warehouseRecountLabelSaveSku(input: {
  searchText: string;
  cardPartNumber: string | null | undefined;
}): string | null {
  void input.searchText;
  const part = input.cardPartNumber?.trim() ?? "";
  if (part === "") {
    return null;
  }
  return part;
}

export async function postWarehouseRecountLabelSave<T>(input: {
  searchText: string;
  cardPartNumber: string | null | undefined;
  save: WarehouseRecountLabelSave;
  post: (sku: string) => Promise<T>;
}): Promise<T | null> {
  if (input.save !== "print-location" && input.save !== "carve") {
    return null;
  }
  const sku = warehouseRecountLabelSaveSku({
    searchText: input.searchText,
    cardPartNumber: input.cardPartNumber,
  });
  if (sku == null) {
    return null;
  }
  return input.post(sku);
}
